<script setup lang="ts">
import {TextInput} from "@hantera/design-system";
import {ref, watch} from "vue";
import useBackend from "@/composition/useBackend";

const props = defineProps<{
  phraseHash: number
  translation: string
  template: string
  lang: string
  context: string
}>();

const { user, fetch } = useBackend();

const textInput = ref();

const inputValue = ref<string>(props.translation);

watch(() => props.translation, () => {
  inputValue.value = props.translation;
});

async function saveTranslation() {
  
  const response = await fetch('/phrases/save', {
    method: 'POST',
    headers: {
      contentType: 'application/json',
    },
    body: JSON.stringify({
      hash: props.phraseHash,
      language: props.lang,
      translation: inputValue.value
    })
  });
  
  if (!response.ok) {
    textInput.value.setError(`Could not save: (${response.status}) ${response.text()}`);
  }
}

</script>

<template>
  <tr>
    <td class="phrases-view__lang">{{lang}}:</td>
    <td class="phrases-view__translation">
      <TextInput
        v-model="inputValue"
        ref="textInput"
        @blur="saveTranslation"
        v-if="user.authorizeSettingsPhrases('write')"
      />
      <template v-else>
        {{translation}}
      </template>
    </td>
  </tr>
</template>

<style>
.phrases-view__lang {
  width: 3em;
  text-transform: uppercase;
}

.phrases-view__translation {
  padding-top: 5px;
}
</style>